import { Box, Typography } from "@mui/material";
import { useTheme } from "../../components/context/context";
import BasicTable from "../../components/basicTable/BasicTable";

export default function District(){
    const {fontSize} = useTheme();
    return(
        <Box sx={{}}>
            <Box sx={{padding: "2px 0 2px 10px", marginTop: "20px", width:"100%"}}>
                 <div style={{fontSize:`${fontSize+0.1}rem`}}>
                 District Social Audit Resource Persons Contact Details
                 </div>
                 <br/>
                 <div style={{display:"flex", justifyContent:"center", width:"100%"}}>

                    <BasicTable heading={heading} data={data}/>
                 </div>
            </Box>
        </Box>
    )
}
const heading=[
    {
        data:"Sl. No.",
        width:"10%"
    },
    {
        data:"Name",
        width:"30%"
    },
    {
        data:"District",
        width:"20%"
    },
    {
        data:"Email Adress",
        width:"20%"
    },
    {
        data:"Phone No.",
        width:"20%"
    }
]

const data=[
    ["1","Podmini Rabha","West Garo Hills","dsarppwghmssat23@gmail.com","9366047151"],
    ["2","Aswinna M. Sangma","South West Garo Hills","sangmaaswina@gmail.com","8787473674/8014437303"],
    ["3","Daphinia Pyngrope","West Jaintia hills","daphinia27@gmail.com","6009425419"],
    ["4","Rinaldi Wanshai Rynjah","East Jaintia Hills","mssatejh@gmail.com","7641034284"],
    ["5","Meritingen Warlarpih","Eastern West Khasi Hills","mssatewkh@gmail.com","8258012454"],
    ["6","Sincerely Kharryngki","South West khasi Hill","mssatswkh@gmail.com","6033140924"],
    ["7","Sengkal A Sangma","West Garo Hills","mssatsgh@gmail.com","9366595714"],
    ["8","Isneilang Lyting","East Khasi Hills","mssatwkh@gmail.com","8787398749"],
    ["9","Kyrmenskhem S Lyngkhoi","East Khasi Hills","kyrmen2017@gmail.com ","8974155971"],
    ["10","Kyntiewlang Siangshai","East Jaintia Hills","kyntiewlangsiangshai@gmail.com","8974362615"],
    ["11","Sanilang Nongrum","East Khasi Hills","sanilangnongrum123@gmail.com","9774761735"],
    ["12","Treskina M Sangma","West Garo Hills","treskinamsangma@gmail.com","8415077252"],
    ["13","Sangra. S. Sangma","West Garo Hills","sangrassangma@gmail.com","7005397133"],
    ["14","Mariana Ch. Sangma","West Garo Hills","marianasangma@gmail.com","7005490996"],
]
